const ProcessStatus = Object.freeze({
    None : 0,
    InProgress:1,
    FailedWithErrors : 2,
    Success : 3,
    0:'None',
    1:'InProgress',
    2:'FailedWithErrors',
    3:'Success'
});

export default ProcessStatus;